<script lang="ts">
  import { Title, List, Card } from '$shared/components';

  interface Props {
    value?: any[];
    onevent?: (payload: any) => void;
  }

  let { value = [], onevent }: Props = $props();

  let hide = $derived(value?.length === 0);
</script>

<div class="npd-report-info-type" class:hide>
  <div class="header"><Title type="h3">Unabridged Report(s) Follow</Title></div>
  {#each value as item}
    <div class="npdb-report-section">
      <Card>
        <div class="npdb-section">
          {#if item.title}
            <div class="title">
              <Title type="h3">{item.title}</Title>
            </div>
          {/if}
          <div class="list">
            <List list={item.list} {onevent} />
          </div>
        </div>
      </Card>
    </div>
  {/each}
</div>

<style>
  .hide {
    display: none;
  }
  .header {
    text-align: center;
    padding: 32px 0px;
  }
  .npdb-report-section {
    margin-bottom: 36px;
  }
  .npdb-section .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .list {
    margin-bottom: 24px;
    margin-top: 24px;
  }
</style>
